import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ variant }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('es') ? 'es' : 'en';

  const toggle = () => {
    const next = currentLang === 'en' ? 'es' : 'en';
    i18n.changeLanguage(next);
    localStorage.setItem('i18nextLng', next);
  };

  if (variant === 'minimal') {
    return (
      <button
        onClick={toggle}
        className="flex items-center gap-1.5 text-sm font-medium px-2.5 py-1.5 rounded-md hover:bg-slate-100 transition-colors"
        data-testid="lang-switcher"
        aria-label="Switch language"
      >
        <Globe className="w-4 h-4" />
        <span className="uppercase">{currentLang}</span>
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-[#0B1F3B] px-2.5 py-1.5 rounded-md hover:bg-slate-100 transition-colors"
      data-testid="lang-switcher"
      aria-label="Switch language"
    >
      <Globe className="w-4 h-4" />
      <span>{currentLang === 'en' ? 'ES' : 'EN'}</span>
    </button>
  );
}
